import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { PopUpCodes } from "../../../../../../common/enum/PopUpCodes";

import { fetchGroupsMerchandiseCategoryRemaining } from "../../../../../../redux/actions/catalog/catalog";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";

import { PopUpForm } from "../../../../../common/popup/popUpForm/popUpForm";
import { validateDefaultForm } from "../../../utils/utils";
import { MasterGroupMerchandiseCategoryForm } from "./form/form";
import { postMasterGroupMerchandiseCategory } from "../../../../../../redux/actions/resources/master/groupMerchandiseCategory/groupMerchandiseCategory";
import { resetMasterGroupMerchandiseCategoryForm } from "../../../../../../redux/reducers/resources/master/groupMerchandiseCategory/form";
import { clearMasterPopUp } from "../../../../../../redux/reducers/resources/master/master";
import { RequiredFieldsMessage } from "../../../../../common/requiredMessage/requiredMessage";
interface IMasterMerchandiseCategoryFormController {
    widthPopUp: any;
    heigthPopUp: any;
}
export const MasterGroupMerchandiseCategoryFormController: React.FC<IMasterMerchandiseCategoryFormController> = ({ heigthPopUp, widthPopUp }) => {
    const { showPopUp } = useAppSelector((state) => state.masterPopUp);
    const { form, loading } = useAppSelector((state) => state.masterGroupMerchandiseCategoryForm);
    const { data } = useAppSelector((state) => state.catalog.groupMerchandiseCategoryRemaining);
    const { t } = useTranslation("common", { keyPrefix: "MASTERS" });
    const dispatch = useAppDispatch();

    const onSavePopUp = () => {
        dispatch(postMasterGroupMerchandiseCategory()).then((response: any) => {
            if (response) {
                onCancelPopUp();
            }
        });
    };
    const onCancelPopUp = () => {
        dispatch(clearMasterPopUp());
    };
    const onDimissed = () => {
        dispatch(resetMasterGroupMerchandiseCategoryForm());
    };
    const title = useMemo(() => {
        if (showPopUp === PopUpCodes.CREATE) {
            return t("CREATE") + " " + t("BUTTON.MERCHANDISE_CATEGORY_GROUP");
        } else if (showPopUp === PopUpCodes.UPDATE) {
            return t("UPDATE") + " " + t("BUTTON.MERCHANDISE_CATEGORY_GROUP");
        }
        return "";
    }, [showPopUp]);
    const isDisabledButton = useMemo(() => {
        return validateDefaultForm(form, showPopUp === PopUpCodes.CREATE);
    }, [form, showPopUp]);

    const showNotData = useMemo(() => {
        return showPopUp === PopUpCodes.CREATE && !data.length ? true : false;
    }, [data, showPopUp]);

    useEffect(() => {
        showPopUp === PopUpCodes.CREATE && dispatch(fetchGroupsMerchandiseCategoryRemaining());
    }, [showPopUp]);

    return (
        <PopUpForm
            content={
                <MasterGroupMerchandiseCategoryForm
                    selectorData={data}
                    showNotData={showNotData}
                />
            }
            title={title}
            isVisible={showPopUp === PopUpCodes.CREATE || showPopUp === PopUpCodes.UPDATE ? true : false}
            onCancel={onCancelPopUp}
            onSave={onSavePopUp}
            onDimissed={onDimissed}
            height={heigthPopUp}
            width={widthPopUp}
            onlyHidden={showNotData}
            isDisabledButton={isDisabledButton}
            isLoading={loading}
            leftButtonContent={<RequiredFieldsMessage />}
        />
    );
};
